import { Injectable, EventEmitter } from '@angular/core';
import axios from 'axios';
import { MessageModel, Size } from '../model/menu.model';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    private rtlLanguages: string[] = ['he', 'ar'];
    private specialLanguages: string[] = ['ru', 'de'];
    private longLanguages: string[] = ['ru'];
    private longheader: string[] = ['fr'];
    private size: Size;
    
    public mappings: string;
    public language: string = 'en';
    public rtl: boolean = false;
    public domain: string = "";
    public settings: any = {};
    public globalTabindex: Number = 0;
    public globalSrHidden: string = "false";
    public isMobile: boolean = false;
    public siteUrl: string;
    public fullUrl: string;
    public locallization: string = null;

    allowFocus: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    public isRtl() {
        return this.rtlLanguages.indexOf(this.language) > -1;
    }

    public setSiteUrl(url) {
        return this.siteUrl = url;
    }
    
    public setFullUrl(url) {
        return this.fullUrl = url;
    }
    
    public setLang(lang: string){
        this.language = lang;
    }
    
    public setSize(size: Size) {
        this.size = size;
    }

    public getHeight(): number {
        if (this.size) {
            return this.size.height;
        }
        return 0;
    }

    public getTop(): number {
        if (this.size) {
            return this.size.top;
        }
        return 0;
    }

    public setMobileDevice(view: string): void {
        this.isMobile = view === "mobile";
    }

    public isFirefox(): boolean {
        return navigator.userAgent.indexOf("Firefox") > -1;
    }

    public postMessage(message: MessageModel) {
        window.parent.postMessage(message, "*");
    }

    public isSpecialStyle(): boolean {
        return this.specialLanguages.indexOf(this.language) > -1;
    }

    public isLongLanguage(): boolean {
        return this.longLanguages.indexOf(this.language) > -1;
    }

    public isLongHeader(): boolean {
        return this.longheader.indexOf(this.language) > -1;
    }

    public allowFocusOnMenu(permission: boolean): any {
        if (permission) {
            this.globalTabindex = 0;
            this.globalSrHidden = "false";
        }
        else {
            this.globalTabindex = -1;
            this.globalSrHidden = "true";
        }

        this.allowFocus.emit();
    }

    public getKeyboardPermission() {
        return this.globalTabindex;
    }

    public getSrPermission() {
        return this.globalSrHidden;
    }

    public isIE() {
        const browserAppName = navigator.appName.toLowerCase();
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (browserAppName === 'netscape' && userAgent.indexOf('trident') > 0) {
            const isIE = new RegExp('trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
            return isIE.exec(userAgent) != null;
        }
        return false;
    }

    public isMac() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf('safari') > -1 && userAgent.indexOf('iphone') === -1 && userAgent.indexOf('chrome') === -1;
    }
}
